import React from 'react'
import AdminDashboard from '../../components/common/Dashboard';

const Dashboard = () => {
  return (
    <AdminDashboard />
  )
}

export default Dashboard;